import { LengthLimitFeature } from "feature/comments/length-limit"
import { UpvoteFeature } from "feature/comments/upvote"
import { DownvoteFeature } from "open-modules/cbcrc/feature/comments/downvote";
import { AgreeDisagreeFeature, CommentSliderEnableVisualizationFeature, CommentSliderFeature, CommentSliderHorizVisualizationFeature, CommentSliderNoDefaultFeature, CommentSliderPollPickerFeature, CommentSliderSliderFeature, CommentSliderVertVisualizationFeature, YesNoFeature } from "./question/comment-slider"
import { ModerateRepliesStrictlyFeature, ModerateWithGPTFeature, ModerateWithJigsawFeature, ModerationHelpFeature, PreModeratorFeature } from "./moderation/ai-premoderator"
import { ProfileArticleRecommendationsFeature } from "open-modules/zdf/feature/profile-article-recommendations"
import { ProfileConversationRecommendationsFeature } from "open-modules/zdf/feature/profile-conversation-recommendations"
import { ProfileInterestsFeature } from "open-modules/zdf/feature/profile-interests"
import { VideoQuoteFeature } from "open-modules/zdf/feature/video-quote"
import { ArticleTopicTaggingFeature } from "open-modules/zdf/feature/article-topic-tag"
import { ConvoMatchFeature } from "open-modules/zdf/feature/convo-match"
import { ProfileAnswersFeature } from "./profile/profile-answers"
import { CMSEmbeddedQuestionTeaserFeature, EditorialQuestionFeature, GreenQuestionTeaserFeature, TanQuestionTeaserFeature } from "./teaser/editorial-question"
import { EmbeddedQuestionTeaserFeature } from "./teaser/embedded-question-teaser"
import { FunReactionsFeature, NewPublicReactionsFeature, PersonalReactionsFeature, ReactionTypesFeature, ReactionTypesMultipleButtonsFeature, ReactionTypesPopupButtonFeature, SeriousReactionsFeature } from "./question/reaction-types"
import { ReplyNotificationsFeature } from "feature/comments/reply-notifs"
import { VideoVotingFeature, VideoVotingVideoOverlayFeature } from "open-modules/zdf/feature/videovoting/video-voting-article"
import { VideoVotingOverviewFeature } from "open-modules/zdf/feature/videovoting/video-voting-overview"
import { ProfileSettingsFeature } from "open-modules/zdf/feature/profile-settings"
import { AccountVideoVotingSettingFeature } from "open-modules/zdf/feature/videovoting/account-video-voting-setting"
import { ZDFDemoFeature } from "demo/zdf/componentdemozdf"
import { RepresentingPerspectivesCardFeature, RepresentingPerspectivesFeature, RepresentingPerspectivesSpeechBubbleFeature, RepresentingPerspectivesSubtleBubbleFeature } from "./question/representing-perspectives"
import { ContextEntryPointsFeature } from "./question/context-entry-points"
import { ProfileTitledWriterFeature } from "open-modules/cbcrc/feature/profile/profile-titled-writer"
import { TitledWriterFeature } from "open-modules/cbcrc/feature/general/titled-writer"
import { TranslationFeature } from "open-modules/srg/translation/TranslationFeature"
import { ConversationHelperAddonFeatures, ConversationHelperFeature, ConversationHelperGuidanceFeedbackSet1Feature, ConversationHelperGuidanceFeedbackSet2Feature } from "open-modules/zdf/feature/conversation-helper"
import { ConversationHelperCommentBasedTimingFeature, ConversationHelperCommentBasedTimingFeature1, ConversationHelperCommentBasedTimingFeature2, ConversationHelperCommentBasedTimingFeature3, ConversationHelperCommentBasedTimingFeature4, ConversationHelperManualTimingFeature, ConversationHelperSettingsFeatures, GuidanceUpdateCommentIntervalFeature0, GuidanceUpdateCommentIntervalFeature1, GuidanceUpdateCommentIntervalFeature2, GuidanceUpdateCommentIntervalFeature3, GuidanceUpdateCommentIntervalFeature4, GuidanceUpdateIntervalFeature } from "open-modules/zdf/feature/conversation-helper-admin"
import { AskMeAnythingTeaserFeature, TopicTeaserFeature } from "open-modules/cbcrc/feature/connect/topic-teaser"
import { PinCommentFeature } from "./question/pin-comment"
import { ReportCommentFeature } from "./moderation/report-comment"
import { AdminModLinkFeature, NewModLinkFeature, EditorialDashFeature } from "./admin/admin-mod-link"
import { HideRejectedFeature } from "./moderation/hide-rejected"
import { HumanReviewsEverythingFeature } from "./moderation/human-reviews-everything"
import { CloseConversationFeature } from "feature/question/close-conversation"
import { OpenLinksInNewTabFeature } from "feature/general/open-links-in-new-tab"
import { BlocklistFeature } from "open-modules/zdf/feature/premoderation/blocklist"
import { CommunityGuidelinesFeature, CommunityGuidelinesLeftFeature } from "./question/community-guidelines"
import { SingleResponseHelpFeature } from "./question/single-response-help"
import { NextTopicPollFeature, TopicPollBottomPositionFeature, TopicPollFeature, TopicPollInContentPositionFeature, TopicPollTopPositionFeature } from "open-modules/cbcrc/feature/topic/topic-poll"
import { TopicOfTheMomentCallToActionFeature, TopicPopularQuestionsFeature, TopicUserQuestionCallToActionFeature, TopicUserQuestionsFeature } from "open-modules/cbcrc/feature/topic/user-questions"
import { TopicRelatedConversationsFeature } from "open-modules/cbcrc/feature/topic/related-conversations"
import { EditorialReadingListFeature } from "open-modules/cbcrc/feature/topic/editorial-reading-list"
import { TopicLiveStatusRightFeature } from "open-modules/cbcrc/feature/topic/live-status"
import { TopicParticipantsFeature } from "open-modules/cbcrc/feature/topic/TopicParticipants"
import { TopicPhotoTeaserForTopicFeature } from "./teaser/topic-photo-teaser"
import { QuestionCardsFeature } from "./topic/question-cards"
import { EmbeddedFeature } from "./question/embedded"
import { ReadingListFeature } from "./topic/reading-list"
import { AskMeAnythingHeaderFeature } from "open-modules/cbcrc/feature/topic/ask-me-anything-header"
import { TopicConfigFeature } from "./topic/topic-config"
import { CommentConfigDemoFeature, DemoSecondaryFeature } from "feature/comments/comment-config"
import { PuppetSupportFeature } from "./admin/puppet-test-support"
import { DemoFilterFeature } from "./comments/demo-filter"
import { BasicTeaserFeature } from "./teaser/basic-teaser"
import { ProfilePhotoAndNameFeature } from "./profile/profile-photo-and-name"
import { AdminUsersFeature } from "./admin/admin-users"
import { AccountDeleteFeature } from "./account/account-delete"
import { AskMeAnythingConfigFeature, BaseTopicConfigFeature, TopicOfTheMomentConfigFeature } from "open-modules/cbcrc/feature/topic/TopicOfTheMomentConfigFeature"
import { PinAnswerFeature } from "open-modules/cbcrc/feature/topic/pin-answer"
import { JumpToCommentFeature } from "open-modules/zdf/feature/jump-to-comment"
import { AutoApproveFeature } from "open-modules/zdf/feature/premoderation/AutoApproveFeature"
import { EnableModDashboardThreadDetailsFeature } from "open-modules/zdf/feature/question/enable-thread-mod-dashboard-view"
import { RecordEntryUrlFeature } from "./question/record-entry-url"
import { AccountRequestDataFeature } from "./account/request-data"
import { QuestionListFeature } from "./admin/question-list"
import { TopicListFeature } from "open-modules/cbcrc/feature/admin/topic-list"
import { AITagFeature } from "./question/ai-tag"
import { CommentsSortFeature } from "open-modules/cbcrc/feature/comments/comments-sort"
import { DeleteCommentsInModDashboardFeature } from "open-modules/zdf/feature/question/delete-commentsin-mod-dashboard"
import { SatisfactionSurveyFeature, UsabilitySurveyFeature } from "./general/survey"
import { VideoVotingListFeature } from "open-modules/zdf/feature/admin/video-voting-list"
import { ExportCommentsFeature, ImportCommentsFeature } from "./developer/import-export"
import { RankingSelectorFeature } from "./ranking/ranking-selector"
import { MostReactedFeature, MostRecentFeature, MostUpvotedFeature, OldestFeature } from "./ranking/simple-ranking"
import { AIQualityRankingFeature, ShowRankingFeaturesFeature } from "./ranking/ai-quality-ranking"
import { EmailPreviewFeature } from "./admin/email-preview"
import { PrivateCommentFeedbackFeature } from "open-modules/zdf/feature/private-comment-feedback"
import { TopTabFeature } from "./ranking/top-tab"
import { DialogueFeature } from "open-modules/srg/feature/question/dialogue"
import { DialogueEmbeddedQuestionTeaserFeature, DialogueGreenQuestionTeaserFeature, DialogueTanQuestionTeaserFeature } from "open-modules/srg/feature/teaser/dialog-teaser"
import { PostAnywayFilterFeature } from "./moddash/post-anyway-filter"
import {ChannelBaseFeature} from "open-modules/zdf/feature/channels/channel-base"
import {ChannelSelectionModDashboardFeature} from "open-modules/zdf/feature/channels/channel-selection"
import { AccountNotificationPermissionFeature } from "open-modules/zdf/feature/account/account-notification-permission"
import { AccountPushNotificationPermissionFeature } from "open-modules/zdf/feature/account/account-push-notification-permission"
import { AdminUsersImportFeature } from "./admin/admin-users-import"
import { PushNotificationFeaturesForThreads } from "open-modules/zdf/feature/pushNotifications/ThreadPushNotification"
import { InstanceManagerFeature } from "./editorial-dash/question-topic-manager"
import { ChannelSelectionFeature } from "open-modules/zdf/feature/editorial-dash/display-channel-selection"
import { OnlyAdminButtonTeaserFeature } from "open-modules/zdf/feature/teaser/only-admin-teaser"
import { ArticleManagerFeature } from "open-modules/zdf/feature/editorial-dash/article-manager"
import { EnableModTaskTreeViewFeature } from "open-modules/zdf/feature/question/enable-mod-task-tree-view"
import { ProfileConfigFeature } from "./profile/profile-config"
import { ProfileCommentsFeature } from "./profile/profile-comments"
import { SECTION, COMPOSITE, CHOOSEONE, FeatureGroup } from "./feature-helpers"
import { AccountEmailNotificationPermissionFeature, AccountEmailNotifModFeature, AccountEmailNotifReplyFeature } from "open-modules/zdf/feature/account/account-email-notification-permission"
import { WarnBlockOverviewFeature } from "open-modules/zdf/feature/account/account-warn-block-overview"
import { ErrorTestFeature } from "./admin/error-test"
import { ChannelSettingsFeature } from "open-modules/zdf/feature/channel-settings"
import { ModDashboardSettingsFeature } from "open-modules/zdf/feature/moddashboard-settings"
import { SpacesFeature } from "./editorial-dash/spaces"
import { CommentSliderTemplateFeature } from "./editorial-dash/templates/comment-slider-template"
import { RepresentingPerspectivesTemplateFeature } from "./editorial-dash/templates/representing-perspectives-template"
import { ConversationHelperTemplateFeature } from "./editorial-dash/templates/conversation-helper-template"
import { DialogueTemplateFeature } from "./editorial-dash/templates/dialogue-template"
import { t } from "util/stdtypes"

export const features : Record<string, FeatureGroup[]> = {
    account: [
        SECTION(t('Account Management'), [
            COMPOSITE(AccountNotificationPermissionFeature, [
                AccountPushNotificationPermissionFeature,
                COMPOSITE(AccountEmailNotificationPermissionFeature,[
                    AccountEmailNotifModFeature,
                    AccountEmailNotifReplyFeature
                ])
            ]),
            AccountRequestDataFeature,
            AccountDeleteFeature,
            WarnBlockOverviewFeature,
        ]),
        SECTION(t('Account Settings'), [
            AccountVideoVotingSettingFeature,
        ])
    ],
    admin: [
        SECTION(t('Admin Modules'), [
            AdminUsersFeature,
            QuestionListFeature,
            TopicListFeature,
            VideoVotingListFeature,
            EmailPreviewFeature,
            AdminUsersImportFeature,
            ErrorTestFeature,
        ]),
        SECTION(t('Quick links'), [
            AdminModLinkFeature,
            NewModLinkFeature,
            EditorialDashFeature
        ]),
        SECTION(t('Screens'), [
            PuppetSupportFeature
        ])
    ],
    article: [
        COMPOSITE(EditorialQuestionFeature, [
            CHOOSEONE(t('Teaser Type'), [
                GreenQuestionTeaserFeature,
                TanQuestionTeaserFeature,
                AskMeAnythingTeaserFeature,
                TopicTeaserFeature,
                DialogueGreenQuestionTeaserFeature,
                DialogueTanQuestionTeaserFeature,
                EmbeddedQuestionTeaserFeature,
            ])
        ]),
        // EditorialQuestionFeature,
        COMPOSITE(VideoVotingFeature, [
            VideoVotingVideoOverlayFeature
        ]),
        SECTION(t("Admin only teaser"), [
            OnlyAdminButtonTeaserFeature
        ])
    ],
    componentdemo: [
        SECTION(t('Core Component Sets'), [
            ZDFDemoFeature,
        ]),
        SECTION(t('Configuration'), [
            OpenLinksInNewTabFeature
        ])
    ],
    moddashboard: [
        COMPOSITE(ChannelBaseFeature,[
            ChannelSelectionModDashboardFeature,
        ]),
        COMPOSITE(ModDashboardSettingsFeature, [
            ChannelSettingsFeature,
        ])
    ],
    editorialdash: [
        SECTION(t('Tabs'), [
            InstanceManagerFeature,
            ArticleManagerFeature,
            COMPOSITE(SpacesFeature, [
                CommentSliderTemplateFeature,
                RepresentingPerspectivesTemplateFeature,
                ConversationHelperTemplateFeature,
                DialogueTemplateFeature
            ])
        ]),
        SECTION(t("Channels"),[
            ChannelSelectionFeature,
        ]),
    ],
    moderationdash: [
        SECTION(t('Filters'), [
            PostAnywayFilterFeature
        ])
    ],
    profile: [
        SECTION(t('Developer'), [
            ProfileConfigFeature,
        ]),
        SECTION(t('General'), [
            ProfilePhotoAndNameFeature,
            ProfileAnswersFeature,
            ProfileCommentsFeature,
        ]),
        SECTION(t('ZDF'), [
            ProfileInterestsFeature,
            ProfileConversationRecommendationsFeature,
            ProfileArticleRecommendationsFeature,
            COMPOSITE(ProfileSettingsFeature, [
            ])
        ]),
        SECTION(t('CBCRC'), [
            ProfileTitledWriterFeature,
        ]),        
    ],
    question: [
        SECTION(t('Conversation Type'), [
            COMPOSITE(CommentSliderFeature, [
                CHOOSEONE(t('Spectrum'), [
                    YesNoFeature,
                    AgreeDisagreeFeature
                ]),
                CHOOSEONE(t('Composer'), [
                    CommentSliderPollPickerFeature,
                    CommentSliderSliderFeature,
                    CommentSliderNoDefaultFeature
                ]),
                COMPOSITE(CommentSliderEnableVisualizationFeature, [
                    CHOOSEONE(null, [
                        CommentSliderHorizVisualizationFeature,
                        CommentSliderVertVisualizationFeature
                    ]),
                ]),
            ]),
            COMPOSITE(RepresentingPerspectivesFeature, [
                CHOOSEONE(t('UI Variant'), [
                    RepresentingPerspectivesCardFeature,
                    RepresentingPerspectivesSpeechBubbleFeature,
                    RepresentingPerspectivesSubtleBubbleFeature
                ]),
            ]),
            DialogueFeature,
            COMPOSITE(ConversationHelperFeature, [
                ...ConversationHelperAddonFeatures,
                CHOOSEONE(t('Feedback Set'), [
                    ConversationHelperGuidanceFeedbackSet1Feature,
                    ConversationHelperGuidanceFeedbackSet2Feature
                ]),
                PrivateCommentFeedbackFeature,
                SECTION(t('Timing of Analysis'), [
                    // TODO: How can we make automatic analysis and manual analysis an "exclusive or"? Being able to turn both on is confusing and doesn't make sense. CHOOSEONE can't have a sub-menu though.
                    COMPOSITE(ConversationHelperCommentBasedTimingFeature, [
                        CHOOSEONE(t('Analyze after every...'), [
                            ConversationHelperCommentBasedTimingFeature1,
                            ConversationHelperCommentBasedTimingFeature2,
                            ConversationHelperCommentBasedTimingFeature3,
                            ConversationHelperCommentBasedTimingFeature4,
                        ]),
                    ]),
                    ConversationHelperManualTimingFeature,
                    COMPOSITE(GuidanceUpdateIntervalFeature, [
                        CHOOSEONE(t("Update based on comments..."), [
                            GuidanceUpdateCommentIntervalFeature0,
                            GuidanceUpdateCommentIntervalFeature1,
                            GuidanceUpdateCommentIntervalFeature2,
                            GuidanceUpdateCommentIntervalFeature3,
                            GuidanceUpdateCommentIntervalFeature4,
                        ]),
                    ]),
                ]),
                ...ConversationHelperSettingsFeatures,

            ]),
        ]),
        SECTION(t('Moderation'), [
            HideRejectedFeature,
            COMPOSITE(PreModeratorFeature, [
                ModerateWithGPTFeature,
                ModerateWithJigsawFeature,
                ModerateRepliesStrictlyFeature,
                BlocklistFeature,
            ]),            
            AutoApproveFeature,
            ModerationHelpFeature,
            ReportCommentFeature,
            TopTabFeature,
            EnableModDashboardThreadDetailsFeature,
            EnableModTaskTreeViewFeature,
            DeleteCommentsInModDashboardFeature
        ]),
        SECTION(t('General'), [
            AITagFeature,
            JumpToCommentFeature,
            LengthLimitFeature,
            CommunityGuidelinesFeature,
            ContextEntryPointsFeature,
            EmbeddedFeature,
            OpenLinksInNewTabFeature,
            PinCommentFeature,
            COMPOSITE(ReactionTypesFeature, [
                CHOOSEONE(t('Interaction'), [
                    ReactionTypesMultipleButtonsFeature,
                    ReactionTypesPopupButtonFeature
                ]),
                CHOOSEONE(t('Reaction Set'), [
                    NewPublicReactionsFeature,
                    SeriousReactionsFeature,
                    PersonalReactionsFeature,
                    FunReactionsFeature,
                ])
            ]),
            RecordEntryUrlFeature,
            VideoVotingOverviewFeature,
            ReplyNotificationsFeature,
            CommentConfigDemoFeature,
            SingleResponseHelpFeature,
            COMPOSITE(CMSEmbeddedQuestionTeaserFeature, [
                DialogueEmbeddedQuestionTeaserFeature
            ]),
            SatisfactionSurveyFeature,
            UsabilitySurveyFeature,
            TitledWriterFeature,
            TranslationFeature,
            UpvoteFeature,
            ExportCommentsFeature,
        ]),
        SECTION(t('Fallbacks'), [
            HumanReviewsEverythingFeature,
            CloseConversationFeature,
        ]),
        SECTION(t('Ranking'), [
            RankingSelectorFeature,
            MostRecentFeature,
            OldestFeature,
            MostUpvotedFeature,
            MostReactedFeature,
            AIQualityRankingFeature,
            ShowRankingFeaturesFeature,
        ]),
        PushNotificationFeaturesForThreads
    ],
    simplecomments: [
        SECTION(t('Developer'), [
            COMPOSITE(CommentConfigDemoFeature, [
                DemoSecondaryFeature,
            ]),
            DemoFilterFeature,
            ImportCommentsFeature,
            ExportCommentsFeature
        ]),
        SECTION(t('General'), [
            UpvoteFeature,
            LengthLimitFeature,
            BasicTeaserFeature,
            ReplyNotificationsFeature,
            CloseConversationFeature,
            OpenLinksInNewTabFeature,
        ]),
        SECTION(t('Ranking'), [
            RankingSelectorFeature,
            MostRecentFeature,
            OldestFeature,
            MostUpvotedFeature,
            MostReactedFeature,
            AIQualityRankingFeature,
            ShowRankingFeaturesFeature,
        ]),
        SECTION(t('PSI Extensions'), [
            CommentSliderFeature,
            TranslationFeature,
            VideoQuoteFeature,
            ArticleTopicTaggingFeature,
            ConvoMatchFeature,
            CommunityGuidelinesFeature,
        ]),
        SECTION(t('Moderation'), [
            HideRejectedFeature,
            COMPOSITE(PreModeratorFeature, [
                ModerateWithGPTFeature,
                ModerateWithJigsawFeature,
                ModerateRepliesStrictlyFeature,
                BlocklistFeature,
            ]),
            AutoApproveFeature,
            ReportCommentFeature,
            HumanReviewsEverythingFeature,
            CloseConversationFeature
        ]),
    ],
    topic: [
        SECTION(t('Topic template'), [
            COMPOSITE(BaseTopicConfigFeature, [
                TopicUserQuestionCallToActionFeature,
            ]),
            COMPOSITE(TopicOfTheMomentConfigFeature, [
                TopicLiveStatusRightFeature,
                TopicParticipantsFeature,
                TopicOfTheMomentCallToActionFeature,
                CommunityGuidelinesLeftFeature,
            ]),
            COMPOSITE(AskMeAnythingConfigFeature, [
                AskMeAnythingHeaderFeature,
                CommunityGuidelinesLeftFeature,
            ]),
        ]),
        SECTION(t('Content'), [
            TopicUserQuestionsFeature, // DEV feature enabled by default
            TopicPopularQuestionsFeature, // DEV feature enabled by default
            COMPOSITE(TopicPollFeature, [
                CHOOSEONE(t('Position'), [
                    TopicPollTopPositionFeature,
                    TopicPollInContentPositionFeature,
                    TopicPollBottomPositionFeature
                ])]),
            TopicRelatedConversationsFeature,
            EditorialReadingListFeature,
            NextTopicPollFeature,
            QuestionCardsFeature, // DEV feature
            UpvoteFeature, // DEV feature enabled by default
            DownvoteFeature,
        ]),
        SECTION(t('Moderation'), [
            HideRejectedFeature, // DEV feature enabled by default
            COMPOSITE(PreModeratorFeature, [
                ModerateWithGPTFeature,
                ModerateWithJigsawFeature,
                ModerateRepliesStrictlyFeature,
                BlocklistFeature,
            ]),
            AutoApproveFeature,
            ModerationHelpFeature, // DEV feature enabled by default
            ReportCommentFeature,
            EnableModDashboardThreadDetailsFeature,
            EnableModTaskTreeViewFeature,
            DeleteCommentsInModDashboardFeature
        ]),
        SECTION(t('General'), [
            CommunityGuidelinesFeature, // DEV feature enabled by default
            ContextEntryPointsFeature,
            ReadingListFeature,
            OpenLinksInNewTabFeature,
            PinCommentFeature,
            ReplyNotificationsFeature, // DEV feature enabled by default
            RecordEntryUrlFeature, // DEV feature enabled by default
            TopicPhotoTeaserForTopicFeature, // DEV feature
            TopicConfigFeature, // DEV feature disabled by default
            TitledWriterFeature, // DEV feature enabled by default
            PinAnswerFeature, // DEV feature enabled by default
            CommentsSortFeature, // DEV feature enabled by default
            SatisfactionSurveyFeature, // DEV feature enabled by default
            UsabilitySurveyFeature, // DEV feature enabled by default
            EnableModDashboardThreadDetailsFeature, // Dev feature, enables detail view within mod dashboard
        ]),
        SECTION(t('Fallbacks'), [
            HumanReviewsEverythingFeature,
            CloseConversationFeature, // this needs to be supported in Topic, right now it doesnt do anything
        ]),
        PushNotificationFeaturesForThreads
    ],
}

export const defaultFeatureConfig = {
    account: {
        profilerequestdata: true,
        profiledelete: true,
        notificationpermission: false,
        pushnotificationpermission: false,
        emailnotificationmoderation: false,
        emailnotificationreplies: false,
        emailnotificationpermission: false
    },
    admin: {
        admin_link_mod: true,
        admin_new_link_mod: true,
        editorialtopic: true,
        puppettest: true,
        videovotinglist: true,
        adminusers: true,
        questionlist: true,
        topiclist: true,
        emailpreview: true,
        adminusersimport: true,
    },
    article: {
        editorialquestion: true,
        videovotingArticle: false,
        videovotingArticleTextIntegration: false
    },
    articlequestions: {
        upvotequestion: true,
        questionteaser: true
    },
    componentdemo: {
        demo_designsystem: true,
        demo_comment: true,
        demo_profile: true,
        demo_eventlog: true,
        demo_profileedit: true,
        demo_admin: true,
        demo_topbar: true,
        demo_basicfeatures: true,
        demo_embedded: true,
        demo_login: true,
        demo_help: true,
        demo_profile_delete: true,
        demo_profileanswers: true,
        demo_poll: true,
        demo_survey: true,
        demo_puppet: true,
        demo_questionbasics: true,
        demo_cbcrc: true,
        demo_zdf: true,
        demo_conversation: true,
        demo_teaser: true,
        demo_fallbacks: true,
        demo_moderationdash: true,
        demo_moderation: true,
        demo_topic: true,
        demo_topic_config: true
    },
    moddashboard: {
        channelbase: false,
        channelassignment: false,
        channeldropdown: false,
        moddashboardsettings: false,
        channelsettings: false,
    },
    moderationdash: {
        post_anyway_filter: true
    },
    profile: {
        profileanswers: true,
        profiledelete: true,
        profileeditname: true,
    },
    simplecomments: {
        openlinksinnewtab: true,
        premoderator: true,
        articletopictagging: false,
        convomatch: false,
        translationfeature: false,
        hide_rejected: true,
        premoderation: true,
        aimoderation: true,
        jigsawmoderation: true,
        strictreplymoderation: true,
        report_comment: true
    },
    question: {
        lengthlimit: false,
        upvote: false,
        reactiontypes: true,
        replynotifications: true,
        commentslider: false,
        translationfeature: false,
        community_guidelines: true,
        votingoverview: false,
        record_entry_url: true,
        aitag: true,
        pin_comment: true,
        single_response_help: true,
        satisfaction_survey: true,
        usability_survey: true,

        jumptocomment: true,
        context_entry_points: true,

        // Radio button first features: TODO - auto-select these
        commentslider_yes: true,
        commentslider_slider: true,
        commentslider_horiz_visualization: true,
        commentslider_enable_visualization: true,
        newpublicreactions: true,
        // representing_perspectives_card: true,
        representing_perspectives_subtle_bubble: true,
        reactiontypesmultiplebuttons: true,

        // Moderation 
        hide_rejected: true,
        aimoderation: true,
        jigsawmoderation: true,
        premoderation: true,
        report_comment: true,
        // moderationhelp: true,
        autoapprovecomments: true,
        deletecommentsinmoddashboard: true,

        //Conversation helper Settings
        conversationhelper_timing_comments: true,
        conversationhelper_timing_comments_1: true,
        conversationhelper_personality_b: true,
        conversationhelper_scope_all_comments: true,
        conversationhelper_scope_threshold_1: true,
        conversationhelper_top_x_percent_3: true,
        conversationhelper_guidance_update_comment_interval_0: true,
        conversationhelper_guidance_feedback_set_1: true,
        conversationhelper_color_purple: true,
        cmsembeddedquestionteaser: true,
        conversationhelper_ai_generated:true,
    },
    topic: {
        editorialtopic: true,
        topictype: true,
        poll: true,
        upvote: true,
        downvote: false,
        commentssort: true,
        premoderator: false,
        record_entry_url: true,
        context_entry_points: true,
        community_guidelines: true,
        pin_comment: true,
        satisfaction_survey: true,
        usability_survey: true,

        // All CBC modules on by default for now
        amaheader: true,
        basetopicconfig: true,
        topicuserctaquestions: true,
        topicpopularquestions: true,
        topicuserquestions: true,
        topicrelatedcontent: true,
        topicpoll: true,
        nexttopicpoll: true,
        topicfollow: true,
        topiclivestatusright: true,
        topicparticipants: true,
        titledWriter: true,
        pin_answer: true,
        tomuserctaquestions: true,

        topicphototeaser_topic: true,
        replynotifications: true,

        // Moderation 
        topicaimoderationtag: true,
        hide_rejected: true,
        aimoderation: true,
        jigsawmoderation: true,
        premoderation: true,
        report_comment: true,
        moderationhelp: true,
        autoapprovecomments: true,
        deletecommentsinmoddashboard: true,
    },
}

export const newFeatures = {}
